/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { createDefaultGridModel, ROW_DELETED_CLASS } from '@gh/common-internal-shared';
import { NumberTypes, State } from '@gh/common-shared';
import { TranslationService } from '@gh/core-mls';
import { buildNumberColumn, GridModel, GridOptionsExt, ManualGridDefinitionWithModel } from '@gh/core-ui-grid';
import { ColDef } from 'ag-grid-community';
import { get } from 'lodash';
import { getHpeComponentItemId, HpeComponentItem } from '../../../resources/hpe-details.model';
import { HpeDetailsState, queryHpeCostCenter, queryHpeEditable, queryHpeUomRefItem } from '../hpe-details.state';

@Injectable()
export class HpeDetailsComponentItemGridDefinition extends ManualGridDefinitionWithModel {

  constructor(private translationService: TranslationService,
              private state: State<HpeDetailsState>) {
    super();
  }

  buildGridModel(): GridModel {
    return createDefaultGridModel({
      editable: this.state.project(queryHpeEditable),
      getId: getHpeComponentItemId,
    });
  }

  buildGridOptions(): GridOptionsExt {
    return {
      defaultColDef: {
        sortable: false,
      },
      rowClassRules: {
        [ROW_DELETED_CLASS]: ({ data }: { data: HpeComponentItem }) => data.isActive !== true,
      },
    };
  }

  buildColumnDefs(): ColDef[] {
    return [{
      field: 'code',
      headerName: this.translationService.get('lbl_code'),
      width: 150,
    }, {
      field: 'name',
      headerName: this.translationService.get('lbl_description'),
      width: 150,
    }, {
      field: 'costCenter',
      headerName: this.translationService.get('lbl_cost_center'),
      width: 150,
      valueFormatter: ({ data }: { data: any }) =>
        get(this.state.project(queryHpeCostCenter, data.costCenterId), 'code', '').toString(),
    }, {
      field: 'quantity',
      headerName: this.translationService.get('lbl_qty'),
      width: 150,
      ...buildNumberColumn(NumberTypes.Quantity),
    }, {
      field: 'cost',
      headerName: this.translationService.get('lbl_cost_dollar'),
      width: 150,
      ...buildNumberColumn(NumberTypes.Price),
    }, {
      field: 'uomCode',
      headerName: this.translationService.get('lbl_uom_abbreviation'),
      width: 150,
      valueFormatter: ({ data }: { data: any }) => get(this.state.project(queryHpeUomRefItem, data.uomId), 'code', ''),
    }, {
      field: 'extension',
      headerName: this.translationService.get('lbl_extension_dollar'),
      width: 150,
      ...buildNumberColumn(NumberTypes.Price),
    }];
  }
}
